export const PASSWORD_RE = /^[a-z0-9]{6,12}$/;

export const PASSWORD_HINT = '(6-12 символов, a-z, 0-9)';

export const PASSWORD_ERROR = 'Пароль должен содержать 6-12 символов: a-z, 0-9';

export function isPasswordValid(password) {
    return PASSWORD_RE.test(password);
}
